import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatDivider} from '@angular/material/divider';
import {NamedRouterLinkDirective} from '@lib/directives/named-router-link/named-router-link.directive';
import {NgClass, NgTemplateOutlet} from '@angular/common';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {RouterSelectors} from '@store/aviary/aviary.adapter';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {FormatPipe} from '@aviary/pipes/format.pipe';

@Component({
  selector: 'px-my-account-nav',
  templateUrl: './my-account-nav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatDivider, NamedRouterLinkDirective, NgTemplateOutlet, MatCard, MatCardTitle, MatCardHeader, MatCardContent, NgClass, SelectPipe, FormatPipe]
})
export class MyAccountNavComponent {

  public readonly accountStatusSelectors = PatronSelectors.AccountStatus;
  public readonly routerSelectors = RouterSelectors;
}
